/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import { MOCK_ENDPOINT } from '../../util/constants';
import {
  DefaultEnvs,
  APIEnvs,
  EndPointsNames,
  ApiOriginType,
  DefaultAPIEnvs,
} from '../../types';
import { Logger } from '../logger';

type KeyTypes = {
  name: EndPointsNames;
  endpoint: string;
  environment: DefaultEnvs;
  type: ApiOriginType;
};

type stackInstances = {
  [envs in APIEnvs]: KeyTypes[];
};

const strLd = 'Smiles-Launchdarkly';

const getStackInstances = (): stackInstances => {
  const apis: any = {};
  Object.entries(DefaultAPIEnvs).forEach(([key, value]) =>
    value.forEach((v: string | number) => {
      const environment = String(v);

      if (environment === 'PRD') {
        apis[environment] = [
          {
            name: 'ApiFileEnvironment',
            endpoint: 'https://www.smiles.com.br/',
            environment: 'production',
            type: 'Smiles-FileEnvironment',
          },
          {
            name: 'ApiLaunchdarklyRelayBLUE',
            endpoint: 'https://ldrelay-blue.smiles.com.br',
            environment: 'production',
            type: strLd,
          },
          {
            name: 'ApiLaunchdarklyRelayGREEN',
            endpoint: 'https://ldrelay-green.smiles.com.br',
            environment: 'production',
            type: strLd,
          },
        ];
      } else {
        if (environment.includes('-N')) {
          const newEnvironment = environment.replace('-N', '');
          apis[environment] = [
            {
              name: 'ApiLaunchdarklyRelayNew',
              endpoint: `https://ldrelay.${newEnvironment.toLowerCase()}.smiles.com.br`,
              environment: key,
              type: strLd,
            },
          ];
        } else {
          apis[environment] = [
            {
              name: 'ApiLaunchdarklyRelay',
              endpoint: `https://ldrelay-${environment.toLowerCase()}.smiles.com.br`,
              environment: key,
              type: strLd,
            },
          ];
        }
      }
    }),
  );

  const mocks = apis?.MOCK;
  apis?.MOCK.push.apply(
    mocks,
    [
      {
        name: 'ApiMain',
      },
      {
        name: 'ApiGwBr',
      },
      {
        name: 'ApiGwBrOther',
      },
      {
        name: 'ApiGwAr',
      },
      {
        name: 'ApiGwArOther',
      },
      {
        name: 'ApiLiferay',
        type: 'Smiles-Liferay',
      },
      {
        name: 'ApiGoogle',
        endpoint: 'https://maps.googleapis.com/maps/api/',
        type: 'Google',
      },
      {
        name: 'ApiUpload',
      },
      {
        name: 'ApiOAG',
      },
      {
        name: 'ApiAuth0',
      },
    ].map((v) => {
      return {
        name: v.name,
        endpoint: v?.endpoint || MOCK_ENDPOINT.endpoint,
        environment: MOCK_ENDPOINT.environment,
        type: v?.type || MOCK_ENDPOINT.type,
      };
    }),
  );

  return apis;
};

const _Apis: stackInstances = getStackInstances();

const _Headers = {
  'Content-Type': 'application/json',
};

export const getEndPoints = (params: { pEvironment: APIEnvs }) => {
  const { pEvironment } = params;
  return _Apis[pEvironment];
};
export const getPropApi = (
  pEvironment: APIEnvs,
  name: string,
): {
  apiType: ApiOriginType;
  endpoint: string;
} => {
  let apiType: ApiOriginType = 'Smiles';
  let endpoint = '#';
  const apis = _Apis[pEvironment];
  const lstResult = apis.filter((api) => api.name === name);
  if (lstResult && lstResult.length > 0) {
    apiType = lstResult[0].type;
    endpoint = lstResult[0].endpoint;
  }
  return { apiType, endpoint };
};

export const updateEndpoints = (environment: APIEnvs, dados: any): boolean => {
  try {
    const endpoints = [..._Apis[environment], ...dados];
    _Apis[environment] = endpoints;
    validateDuplicatedEndpoints(environment);
  } catch (error) {
    Logger.error(error);
    return false;
  }
  return true;
};

// loosely based on https://stackoverflow.com/a/19395302
const validateDuplicatedEndpoints = (environment: APIEnvs) => {
  const apis: KeyTypes[] = _Apis[environment];
  const occurrences: Record<string, number> = {};

  for (const api of apis) {
    if (occurrences[api.name] === undefined) {
      occurrences[api.name] = 0;
    }
    occurrences[api.name] += 1;
  }

  const duplicatedEndpoints = Object.entries(occurrences).filter(
    (dup) => dup[1] > 1,
  );

  for (const duplicate of duplicatedEndpoints) {
    Logger.warn(
      `[Endpoints] Endpoint ${duplicate[0]} is registered ${duplicate[1]} times`,
    );
  }
};

export const Headers = () => _Headers;
